import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { PremiumRole } from '../domains/premium-role';
import { LoadPremiumRoles, LoadPremiumRolesSuccess, LoadPremiumRolesFail } from './premium-role.actions';
import { PremiumRoleService } from '@smatchy/sdk';
export interface PremiumRoleStateModel {
  roles: PremiumRole[];
  loading: boolean;
  error?: unknown;
}

@State<PremiumRoleStateModel>({
  name: 'premiumRoles',
  defaults: {
    roles: [],
    loading: false,
  },
})
@Injectable()
export class PremiumRoleState {
  constructor(private service: PremiumRoleService) {}

  @Action(LoadPremiumRoles)
  load(ctx: StateContext<PremiumRoleStateModel>) {
    ctx.patchState({ loading: true, error: null });

    return this.service.getAllPremiumRole().pipe(
      tap(
        (roles) => {
          console.log('[LoadPremiumRoles] API success:', roles);
          return ctx.dispatch(new LoadPremiumRolesSuccess(roles as unknown as PremiumRole[]));
        },
        catchError((error) => {
          console.error('[LoadPremiumRoles] API error:', error);
          ctx.dispatch(new LoadPremiumRolesFail(error));
          return of(error);
        }),
      ),
    );
  }

  @Action(LoadPremiumRolesSuccess)
  loadSuccess(ctx: StateContext<PremiumRoleStateModel>, action: LoadPremiumRolesSuccess) {
    console.log('[LoadPremiumRoles] API success:', action);
    ctx.patchState({ roles: action.roles, loading: false });
  }

  @Action(LoadPremiumRolesFail)
  loadFail(ctx: StateContext<PremiumRoleStateModel>, action: LoadPremiumRolesFail) {
    console.error('[LoadPremiumRoles] API error:', action);
    ctx.patchState({ loading: false, error: action.error });
  }
}
